import React from 'react';
import * as yup from 'yup';

interface IDataValidatorProps {
  children?: any;

  rules: {
    [fieldName: string]: yup.Schema<any>;
  };

  data: any;
  isValid: (isValid: boolean) => void;
  onError?: () => object;
}

export class DataValidator extends React.Component<IDataValidatorProps> {
  constructor(props) {
    super(props);
    this.doValidation = this.doValidation.bind(this);
  }

  public componentWillReceiveProps(
    oldProps: IDataValidatorProps,
    newProps: IDataValidatorProps
  ) {
    this.doValidation();
  }

  public doValidation() {
    const { rules, data } = this.props;
    // Create YUP Validation schema from rules
    const validationSchema = yup.object().shape(rules);

    validationSchema
      .validate(data)
      .then(valid => {
        return valid;
      })
      .catch(validError => {
        // console.error(validError);
      });
  }

  public render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/validation/data/DataValidator.tsx